import { ImageIcon } from "lucide-react";

// Reusable image component with graceful placeholder + lazy loading.
export const ImagePlaceholder = ({
  src,
  alt,
  className = "",
  ratio = "aspect-[4/3]",
  label,
  testId,
}) => {
  if (src) {
    return (
      <div className={`relative ${ratio} overflow-hidden rounded-3xl bg-[#F4F9FF] ${className}`} data-testid={testId}>
        <img
          src={src}
          alt={alt}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>
    );
  }
  return (
    <div
      className={`relative ${ratio} overflow-hidden rounded-3xl bg-gradient-to-br from-[#F4F9FF] to-[#E5F0FA] border border-[#E5F0FA] flex items-center justify-center ${className}`}
      data-testid={testId}
      role="img"
      aria-label={alt}
    >
      <div className="flex flex-col items-center text-[#4B6B86]">
        <ImageIcon size={36} strokeWidth={1.5} />
        <span className="mt-2 text-xs font-medium">{label || "Image placeholder"}</span>
      </div>
    </div>
  );
};

export default ImagePlaceholder;
